import { type StateCreator } from 'zustand';

export type CollapseSlice = {
  collapsed: boolean;
  touched: boolean;
  clearCollapsed: () => void;
  setCollapsed: (collapsed: boolean) => void;
  toggleCollapsed: () => void;
};

export type CreateCollapseSlice = (
  initialState: Pick<Partial<CollapseSlice>, 'collapsed' | 'touched'>,
) => StateCreator<CollapseSlice, [], [], CollapseSlice>;

export const createCollapseSlice: CreateCollapseSlice = (initialState) => (set) => ({
  collapsed: initialState.collapsed ?? false,
  touched: initialState.touched ?? false,
  clearCollapsed: () =>
    set({
      collapsed: initialState.collapsed ?? false,
      touched: initialState.touched ?? false,
    }),
  setCollapsed: (collapsed) => set({ collapsed, touched: true }),
  toggleCollapsed: () => set((state) => ({ collapsed: !state.collapsed, touched: true })),
});
